import { css, SerializedStyles } from '@emotion/react';
import globalStyle from '../../../../shared/global.style';
import { getBackgroundColor, getFontColor } from '../../../../shared/models/employeeCard';
import goldCardBackground from '../../../../assets/gold-card-background.jpg';
import silverCardBackground from '../../../../assets/silver-card-background.jpg';

const container = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
const header = css`
  width: 335px;
  padding: 25px 0 35px 0;
`;

const goldCardContainer = css`
  background-image: url(${goldCardBackground});
  background-size: cover;
  background-position: center;
`;

const silverCardContainer = css`
  background-image: url(${silverCardBackground});
  background-size: cover;
  background-position: center;
`;

const getSpecialCaseContainer = (
  isSpecialCaseGoldCard: boolean | undefined,
  isSpecialCaseSilverCard: boolean | undefined
): SerializedStyles | string => {
  if (isSpecialCaseGoldCard) {
    return goldCardContainer;
  }

  if (isSpecialCaseSilverCard) {
    return silverCardContainer;
  }

  return '';
};

const contentContainer = (
  brandCode: string,
  isBlocked: boolean | undefined,
  isSpecialCaseGoldCard: boolean | undefined,
  isSpecialCaseSilverCard: boolean | undefined
): SerializedStyles => {
  return css`
    background-color: ${getBackgroundColor(brandCode, isBlocked)};
    ${getSpecialCaseContainer(isSpecialCaseGoldCard, isSpecialCaseSilverCard)};
    color: ${getFontColor(brandCode, isSpecialCaseGoldCard, isSpecialCaseSilverCard)};
    height: 100%;
    max-height: 556px;
    min-height: 450px;
    width: 100%;
    max-width: 335px;
    border-radius: 10px;
    background-size: cover;
    margin-top: 14px;
    opacity: ${isBlocked ? 0.1 : 1};
    position: relative;
  `;
};

const wrapper = css`
  position: relative;
  height: 100%;
  max-height: 556px;
  width: 100%;
  max-width: 335px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const content = css`
  position: relative;
  padding: 35px 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
`;

const employeeInitials = css`
  ${globalStyle.bodyNormal};
  &&& {
    font-size: 55px;
  }
  letter-spacing: -3px;
  color: var(--dcd-white-color);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: var(--dcd-pink-color-90);
  height: 150px;
  width: 150px;
`;

const circularImage = css`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
`;

const nameSection = css`
  text-align: center;
`;

const emailSection = css`
  text-align: center;
`;

const name = css`
  ${globalStyle.bodyNormal};
  &&& {
    font-weight: 700;
  }
`;

const job = css`
  ${globalStyle.bodyNormal};
`;

const info = css`
  ${globalStyle.bodySmall};
  font-size: 10px;
`;

const discount = css`
  font-size: 36px;
`;

const qrCode = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 75px;
  height: 75px;
  cursor: pointer;
  img {
    border-radius: 5px;
  }
`;

const blockedCardMessage = css`
  color: var(--dcd-black-color);
  border-radius: 10px;
  text-align: center;
  position: absolute;
  z-index: 1;
  max-width: 270px;
  bottom: 40%;
`;

const lockIcon = css`
  color: var(--dcd-gray-color-70);
  text-align: center;
  position: absolute;
  z-index: 1;
  &&& {
    ::before {
      font-size: 80px;
      position: absolute;
      left: -150%;
      bottom: 350%;
    }
  }
`;

const downloadButton = css`
  position: absolute;
  top: -10px;
  right: -15px;
  &&& {
    border-radius: 50%;
    width: 55px;
    height: 55px;
    background-color: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }
`;

const downloadIcon = css`
  margin: 0 0 4px !important;
  color: var(--dcd-pink-color-100);
`;

export default {
  container,
  header,
  contentContainer,
  wrapper,
  content,
  nameSection,
  emailSection,
  name,
  job,
  info,
  discount,
  qrCode,
  blockedCardMessage,
  lockIcon,
  downloadButton,
  downloadIcon,
  employeeInitials,
  circularImage,
};
